// ── Route paths ───────────────────────────────────────────────────────────────
export const DASHBOARD = "/";
export const ABOUT_US = "/AboutUs";
export const TRANSPARENCY = "/Transparency";
export const PRIVACY_POLICY = "/PrivacyPolicy";
export const IMPACT_ATHELETE_JOURNEY = "/ImpactAthleteJourney";
export const NIL_COMPLIANCE_AND_PROCEDURES = "/NILComplianceAndProcedures";
export const ADDRESSING_NIL_INEQUALITY = "/AddressingNILInequality";
export const BUILDING_TRUST_IN_NIL = "/BuildingTrustInNIL";
export const NIL_SUPPORT_SERVICES_AND_FEES = "/NILSupportServices";
export const ACCOUNT_INFORMATION = "/AccountInformation";
export const DELETE_SCREEN = "/DeleteScreen";
export const ADMIN_DASHBOARD = "/AdminDashboard";
export const CONTACT_US = "/contactus";
export const FAVORITES = "/favorites";
export const PAYMENT_SUCCESS = "/success";
export const PAYMENT_FAILED = "/failed";

// Browse routes. Both render the same Dashboard in different modes.
export const FAN_EXPERIENCE_BROWSE = "/dashboard/start-your-fan-experience";
export const BRAND_PARTNERSHIP_BROWSE = "/dashboard/start-your-brand-partnership";

// ── Sports ───────────────────────────────────────────────────────────────────
// The canonical list lives in the database and is served by /v1/get_all_sports,
// which the filters sidebar fetches. This map exists only so a sport arriving as
// an id in the URL can be labelled synchronously on first paint, before that
// request resolves. Keep ids in sync with the sports table.
export const SPORT_NAMES = {
  1: "Men's Basketball",
  2: "Men's Football",
  3: "Women's Basketball",
  4: "Men's Baseball",
  5: "Men's Golf",
  6: "Men's Swimming and Diving",
  7: "Men's Tennis",
  8: "Men's Volleyball",
  9: "Women's Beach Volleyball",
  10: "Women's Cross Country",
  11: "Women's Golf",
  12: "Women's Sailing",
  13: "Women's Soccer",
  14: "Women's Softball",
  15: "Women's Swimming and Diving",
  16: "Women's Tennis",
  17: "Women's Track and Field",
  18: "Women's Volleyball",
  19: "Women's Water Polo",
};

// Sport shown when the user has not chosen one.
export const DEFAULT_SPORT_ID = 2;

export const DEFAULT_SPORT = {
  value: DEFAULT_SPORT_ID,
  label: SPORT_NAMES[DEFAULT_SPORT_ID],
};

// Abbreviation → full name, for labelling the position filter.
export const GAME_POSITIONS = {
  G: "Guard",
  SG: "Shooting Guard",
  PG: "Point Guard",
  F: "Forward",
  PF: "Power Forward",
  C: "Center",
  ATH: "Athlete",
  QB: "Quarterback",
  RB: "Running Back",
  FB: "Full Back",
  WR: "Wide Receiver",
  TE: "Tight End",
  CB: "Cornerback",
  DE: "Defensive End",
  EDGE: "Edge Rusher",
  S: "Safety",
  DL: "Defensive Line",
  KR: "Kick Returner",
  OT: "Offensive Tackle",
  LB: "Linebacker",
  P: "Punter",
  OL: "Offensive Line",
  DT: "Defensive Tackle",
  DB: "Defensive Back",
  PK: "Place Kicker",
  Center: "Center",
  NT: "Nose Tackle",
  LS: "Long Snapper",
  SF: "Small Forward",
};

// ── Paging ───────────────────────────────────────────────────────────────────
export const PAGE_SIZE = 21;

// ── Canonical URLs ───────────────────────────────────────────────────────────
// The athlete permalink is id-first: `player_id` carries the identity and the
// slug is decoration. That is what makes a shared link survive both a name
// correction and a transfer — the old `/DetailsView/:playerId/:teamId` shape
// 404'd as soon as an athlete changed schools, because the team was in the URL.
export const ATHLETE_BROWSE = "/browse";

export const playerUrl = (player) =>
  `/p/${player.player_id}-${player.slug || ""}`.replace(/-$/, "");

export const teamUrl = (sportSlug, teamSlug) => `/sports/${sportSlug}/${teamSlug}`;

export const sportUrl = (sportSlug) => `/sports/${sportSlug}`;

/**
 * Pull the id out of a `/p/{id}-{slug}` segment.
 * A mismatched or missing slug still resolves, so old links keep working and
 * the page can 301 itself to the canonical form.
 */
export const playerIdFromParam = (param) => {
  const id = parseInt(String(param || "").split("-")[0], 10);
  return Number.isNaN(id) ? null : id;
};
